module.exports = __webpack_public_path__ + "static/media/csv_format_bulk_visitor.4fb3ddfa.csv";